/**
 * modalが表示中かどうかの判定
 * @param modal
 * @param modalType
 * @returns {boolean}
 */
export const isShowModal = (modal, modalType) => !!(modal[modalType] && modal[modalType].show);
/**
 * modalに渡している値の取得
 * @param modal
 * @param modalType
 * @returns {*|{}}
 */
export const getModalValue = (modal, modalType) => modal[modalType] || {};
